import React from "react";
import './footer.scss';
import Wrapper from "../Wrapper/wrapper.js";
import {graphql, useStaticQuery} from "gatsby";
import RichText from "../../modules/RichText/richText";

const Footer = () => {
    const myQuery = useStaticQuery(query);
    const config = myQuery.site.siteMetadata.config;
    const static_text = require("../../../content/" + config.country + "/static-text.json");

    return (
        <footer className="footer">
            <Wrapper>
                <RichText white small content={static_text.footer_text1}/>
                <RichText white small content={static_text.footer_text2}/>
            </Wrapper>
        </footer>
    )
};

export default Footer

const query = graphql`
  query {
    site {
      siteMetadata {
        config {
          country
        }
      }
    }
  }
`;